import * as i0 from '@angular/core';
import { Injectable, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from 'reference-library';
import * as i3 from '@angular/common';
import * as i4 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i5 from '@progress/kendo-angular-toolbar';
import * as i6 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i1$1 from 'angular-froala-wysiwyg';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { PrimengLibraryModule } from 'primeng-library';

class CommonEditorService {
    constructor() { }
}
CommonEditorService.ɵfac = function CommonEditorService_Factory(t) { return new (t || CommonEditorService)(); };
CommonEditorService.ɵprov = i0.ɵɵdefineInjectable({ token: CommonEditorService, factory: CommonEditorService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonEditorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["froalaForm"];
const _c1 = ["commonkendoeditorupload"];
const _c2 = ["commonkendoeditor"];
class CommonEditorComponent {
    constructor(fb, referenceLibraryService) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        // customText: FormGroup;
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        if (this.inputParams.name === 'welcomeEmailContent') {
            this.referenceLibraryService
                .getDataSource('FB_ONB_WELCOME_EMAIL_SETUP', '')
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                var _a;
                this.commonkendoeditorStr = (_a = response[0]) === null || _a === void 0 ? void 0 : _a.description;
            });
        }
        this.commonkendoeditorStr = this.inputParams.value;
        this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value));
    }
    commonkendoeditorimageuploaddialog() {
        this.commonkendoeditorupload.open();
    }
    commonkendoeditorValueChange(value) {
        //this.commonkendoeditorStr = value;    
        this.group.get([this.inputParams.name]).patchValue(this.commonkendoeditorStr);
    }
}
CommonEditorComponent.ɵfac = function CommonEditorComponent_Factory(t) { return new (t || CommonEditorComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService)); };
CommonEditorComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CommonEditorComponent, selectors: [["common-editor"]], viewQuery: function CommonEditorComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.froalaForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.commonkendoeditorupload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.commonkendoeditor = _t.first);
    } }, inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", group: "group" }, outputs: { commonkendoeditor: "commonkendoeditor" }, decls: 58, vars: 5, consts: [[1, "col-md-12", "pl-0", "mt-2", 3, "formGroup", "ngStyle"], [1, "customInputContainer"], [2, "height", "500px", 3, "formControlName"], ["commonkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["title", "Upload\u2019s Image at cursor point", "text", "Upload Image", 3, "click"], [3, "editor"], ["commonkendoeditorupload", ""]], template: function CommonEditorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "kendo-editor", 2, 3);
        i0.ɵɵelementStart(4, "kendo-toolbar");
        i0.ɵɵelementStart(5, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(6, "kendo-toolbar-button", 4);
        i0.ɵɵelement(7, "kendo-toolbar-button", 5);
        i0.ɵɵelement(8, "kendo-toolbar-button", 6);
        i0.ɵɵelement(9, "kendo-toolbar-button", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(11, "kendo-toolbar-button", 8);
        i0.ɵɵelement(12, "kendo-toolbar-button", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(14, "kendo-toolbar-button", 10);
        i0.ɵɵelement(15, "kendo-toolbar-button", 11);
        i0.ɵɵelement(16, "kendo-toolbar-button", 12);
        i0.ɵɵelement(17, "kendo-toolbar-button", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "kendo-toolbar-dropdownlist", 14);
        i0.ɵɵelement(19, "kendo-toolbar-dropdownlist", 15);
        i0.ɵɵelement(20, "kendo-toolbar-dropdownlist", 16);
        i0.ɵɵelement(21, "kendo-toolbar-colorpicker", 17);
        i0.ɵɵelement(22, "kendo-toolbar-colorpicker", 18);
        i0.ɵɵelementStart(23, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(24, "kendo-toolbar-button", 19);
        i0.ɵɵelement(25, "kendo-toolbar-button", 20);
        i0.ɵɵelement(26, "kendo-toolbar-button", 21);
        i0.ɵɵelement(27, "kendo-toolbar-button", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(28, "kendo-toolbar-button", 23);
        i0.ɵɵelement(29, "kendo-toolbar-button", 24);
        i0.ɵɵelementStart(30, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(31, "kendo-toolbar-button", 25);
        i0.ɵɵelement(32, "kendo-toolbar-button", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(34, "kendo-toolbar-button", 27);
        i0.ɵɵelement(35, "kendo-toolbar-button", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(36, "kendo-toolbar-button", 29);
        i0.ɵɵelement(37, "kendo-toolbar-button", 30);
        i0.ɵɵelement(38, "kendo-toolbar-button", 31);
        i0.ɵɵelement(39, "kendo-editor-insert-table-button");
        i0.ɵɵelementStart(40, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(41, "kendo-toolbar-button", 32);
        i0.ɵɵelement(42, "kendo-toolbar-button", 33);
        i0.ɵɵelement(43, "kendo-toolbar-button", 34);
        i0.ɵɵelement(44, "kendo-toolbar-button", 35);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(46, "kendo-toolbar-button", 36);
        i0.ɵɵelement(47, "kendo-toolbar-button", 37);
        i0.ɵɵelement(48, "kendo-toolbar-button", 38);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(50, "kendo-toolbar-button", 39);
        i0.ɵɵelement(51, "kendo-toolbar-button", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(52, "kendo-toolbar-button", 41);
        i0.ɵɵelementStart(53, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(54, "kendo-toolbar-button", 42);
        i0.ɵɵelementStart(55, "kendo-toolbar-button", 43);
        i0.ɵɵlistener("click", function CommonEditorComponent_Template_kendo_toolbar_button_click_55_listener() { return ctx.commonkendoeditorimageuploaddialog(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(56, "app-upload-image-dialog", 44, 45);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(3);
        i0.ɵɵproperty("formGroup", ctx.group)("ngStyle", ctx.inputParams.style);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formControlName", ctx.inputParams.name);
        i0.ɵɵattribute("name", ctx.formControlName);
        i0.ɵɵadvance(54);
        i0.ɵɵproperty("editor", _r0);
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i3.NgStyle, i4.EditorComponent, i1.NgControlStatus, i1.FormControlName, i5.ToolBarComponent, i5.ToolBarButtonGroupComponent, i5.ToolBarButtonComponent, i4.EditorBoldButtonDirective, i4.EditorItalicButtonDirective, i4.EditorUnderlineButtonDirective, i4.EditorStrikethroughButtonDirective, i4.EditorSubscriptButtonDirective, i4.EditorSuperscriptButtonDirective, i4.EditorAlignLeftButtonDirective, i4.EditorAlignCenterButtonDirective, i4.EditorAlignRightButtonDirective, i4.EditorAlignJustifyButtonDirective, i4.EditorFormatComponent, i4.EditorFontSizeComponent, i4.EditorFontFamilyComponent, i4.EditorColorPickerComponent, i4.EditorForeColorDirective, i4.EditorBackColorDirective, i4.EditorInsertUnorderedListButtonDirective, i4.EditorInsertOrderedListButtonDirective, i4.EditorIndentButtonDirective, i4.EditorOutdentButtonDirective, i4.EditorBlockquoteDirective, i4.EditorSelectAllButtonDirective, i4.EditorUndoButtonDirective, i4.EditorRedoButtonDirective, i4.EditorCreateLinkButtonDirective, i4.EditorUnlinkButtonDirective, i4.EditorInsertFileButtonDirective, i4.EditorViewSourceButtonDirective, i4.EditorCleanFormattingButtonDirective, i4.EditorInsertTableButtonComponent, i4.EditorAddColumnBeforeButtonDirective, i4.EditorAddColumnAfterButtonDirective, i4.EditorAddRowBeforeButtonDirective, i4.EditorAddRowAfterButtonDirective, i4.EditorDeleteColumnButtonDirective, i4.EditorDeleteRowButtonDirective, i4.EditorDeleteTableButtonDirective, i4.EditorMergeCellsButtonDirective, i4.EditorSplitCellButtonDirective, i4.EditorPrintDirective, i4.EditorInsertImageButtonDirective, i6.UploadImageDialogComponent], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonEditorComponent, [{
        type: Component,
        args: [{
                selector: 'common-editor',
                templateUrl: 'common-editor.component.html',
                styleUrls: ['common-editor.component.scss'
                ]
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.ReferenceLibraryService }]; }, { froalaForm: [{
            type: ViewChild,
            args: ['froalaForm', { static: true }]
        }], formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], commonkendoeditorupload: [{
            type: ViewChild,
            args: ["commonkendoeditorupload"]
        }], commonkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["commonkendoeditor"]
        }], group: [{
            type: Input
        }] }); })();

class CommonEditorModule {
}
CommonEditorModule.ɵfac = function CommonEditorModule_Factory(t) { return new (t || CommonEditorModule)(); };
CommonEditorModule.ɵmod = i0.ɵɵdefineNgModule({ type: CommonEditorModule });
CommonEditorModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            FroalaEditorModule.forRoot(),
            FroalaViewModule.forRoot(),
            PrimengLibraryModule,
            EditorModule,
            EditorLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CommonEditorModule, { declarations: [CommonEditorComponent], imports: [FormsModule,
        ReactiveFormsModule, i1$1.FroalaEditorModule, i1$1.FroalaViewModule, PrimengLibraryModule,
        EditorModule,
        EditorLibraryModule], exports: [CommonEditorComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CommonEditorModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonEditorComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    FroalaEditorModule.forRoot(),
                    FroalaViewModule.forRoot(),
                    PrimengLibraryModule,
                    EditorModule,
                    EditorLibraryModule
                ],
                exports: [CommonEditorComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of common-editor
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CommonEditorComponent, CommonEditorModule, CommonEditorService };
//# sourceMappingURL=common-editor.js.map
